<template>
  <div id="screen">
    <div
      id="header"
      v-bind:class="[isPC ? 'PC2' : 'mobile']"
      v-bind:style="{ 'justify-content': positionChange }"
    >
      <img id="nr" src="./assets/nrLogo.png" />
      <span id="title">NoelRecords</span>

      <social-bar id="header2"> </social-bar>
    </div>

    <div id="content">
      <div>
        <linkComponent :linkDescription="linkDescription" :url="linkUrl" />
      </div>

      <div class="thema" v-bind:class="{ PC3: isPC }">
        文字でつたエール
      </div>
      <!--  -->
      <div class="icons" v-bind:class="{ PC: isPC }">
        <icon :imgSrc="appIconTopImg" :height="newAppIconHeight" />
        <icon3
          :name1="topApp1"
          :name2="topApp2"
          :url1="topAppUrl1"
          :url2="topAppUrl2"
          :height2="newAppIconHeight2"
        />
        <appText
          class="appText"
          :appDescription="topAppDescription"
          v-bind:class="{ PC4: isPC }"
        />
      </div>
      <!--  -->
      <div class="thema" v-bind:class="{ PC3: isPC }">
        新着YouTube動画
      </div>
      <div class="youtube" v-bind:class="{ PC5: isPC }">
        <iframe
          src="https://youtu.be/6QjNFL-8xw0"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
      <div class="thema" v-bind:class="{ PC3: isPC }">
        SNS
      </div>
      <div class="icons" v-bind:class="{ PC: isPC }">
        <icon
          :name="youtube"
          :imgSrc="youtubeImg"
          :url="youtubeUrl"
          :height="youtubeHeight"
        />
        <icon
          :name="note_programming"
          :imgSrc="noteImg"
          :url="note_programmingUrl"
          :height="noteHeight"
        />
      </div>
      <div class="icons" v-bind:class="{ PC: isPC }">
        <icon
          :name="instagram"
          :imgSrc="instagramImg"
          :height="instagramHeight"
          :url="instagramUrl"
        />
        <icon
          :name="twitter"
          :imgSrc="twitterImg"
          :height="twitterHeight"
          :url="twitterUrl"
        />
      </div>
      <div class="icons" v-bind:class="{ PC: isPC }">
        <icon
          :name="note_eng"
          :imgSrc="noteImg"
          :height="noteHeight"
          :url="note_engUrl"
        />
        <icon />
      </div>
      <div id="end"></div>

      <div class="thema" v-bind:class="{ PC3: isPC }">
        NoelRecordsが配信中のアプリ
      </div>
      <div class="icons" v-bind:class="{ PC: isPC }">
        <icon :name="iOS" :imgSrc="iOSImg" :url="iOSUrl" />
        <icon :name="android" :imgSrc="androidImg" :url="androidUrl" />
      </div>

      <div class="thema" v-bind:class="{ PC3: isPC }">
        接客英語アプリ（人気アプリ）
      </div>
      <div class="icons" v-bind:class="{ PC: isPC }">
        <icon :imgSrc="appIconImg" :height="newAppIconHeight" />
        <icon2
          :name1="appIcon"
          :name2="appIconAndroid"
          :url1="appStoreUrl_iOS"
          :url2="appStoreUrl_Android"
          :height2="newAppIconHeight2"
        />
        <appText
          class="appText"
          :appDescription="appDescription0"
          v-bind:class="{ PC4: isPC }"
        />
      </div>

      <div class="thema" v-bind:class="{ PC3: isPC }">
        縮小カメラ（注目アプリ）
      </div>
      <div class="icons" v-bind:class="{ PC: isPC }">
        <icon :imgSrc="newAppImg" :height="newAppIconHeight" />
        <icon2
          :name1="newAppiOS"
          :name2="newAppAndroid"
          :url1="iOSStoreUrl"
          :url2="googleStoreUrl"
          :height2="newAppIconHeight2"
        />
        <appText
          class="appText"
          :appDescription="appDescription1"
          v-bind:class="{ PC4: isPC }"
        />
      </div>
      <div class="icons" v-bind:class="{ PC: isPC }">
        <icon :imgSrc="newAppImg2" :height="newAppIconHeight" />
        <icon2
          :name1="newAppiOS2"
          :name2="newAppAndroid2"
          :url1="iOSStoreUrl2"
          :url2="googleStoreUrl2"
          :height2="newAppIconHeight2"
        />
        <appText
          class="appText"
          :appDescription="appDescription2"
          v-bind:class="{ PC4: isPC }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import icon from "./components/icon.vue";
import icon2 from "./components/icon2.vue";
import icon3 from "./components/icon3.vue";
import appText from "./components/appText.vue";
import linkComponent from "./components/link.vue";
import socialBar from "./components/socialBar.vue";

export default {
  name: "App",
  components: {
    icon,
    icon2,
    icon3,
    appText,
    linkComponent,
    socialBar,
  },
  data() {
    return {
      linkDescription:
        "アプリ紹介メディア「Appliv」に和製英語アプリのレビューが掲載されています！！",
      linkUrl: "https://app-liv.jp/4164271/",
      appDescription0:
        "接客業や飲食業でよく使う英語フレーズを多数収録しています。\n各フレーズはタップで英語音声が再生されます。また全ての英語フレーズにはカタカナ読みも表記しているので覚えやすくなっています。",
      appIconTopImg: require("./assets/icon.png"),
      topApp1: "文字でつたエール公式サイト",
      topApp2: "文字でつたエールストア",
      topAppUrl1: "https://noelrecords-apps.web.app/subtitletool.html",
      topAppUrl2:
        'https://apps.microsoft.com/store/detail/%E6%96%87%E5%AD%97%E3%81%A7%E3%81%A4%E3%81%9F%E3%82%A8%E3%83%BC%E3%83%AB/9P6HS3NF60HC?hl=ja-jp&gl=jp"',
      topAppIconHeight: { height: "60px" },
      topAppDescription:
        "「文字でつたエール」は私のように言語・聴覚の制限を持つ方にもコミュニケーションを支援するWindowsアプリです。\n\nリアルタイムでキーボードから字幕を作成でき、LINEやZOOM等で使えます。",
      appIcon: "接客英語アプリiOS",
      appIconAndroid: "接客英語アプリAndroid",
      appIconImg: require("./assets/sekkyakueigoLogo.png"),
      appStoreUrl_iOS:
        "https://apps.apple.com/us/app/%E6%8E%A5%E5%AE%A2%E8%8B%B1%E8%AA%9E%E3%82%A2%E3%83%97%E3%83%AA-%E6%AD%A3%E3%81%97%E3%81%84%E6%8E%A5%E5%AE%A2%E8%8B%B1%E4%BC%9A%E8%A9%B1%E3%83%95%E3%83%AC%E3%83%BC%E3%82%BA%E3%81%A7%E9%9B%86%E5%AE%A2%E5%8A%9B%E3%82%A2%E3%83%83%E3%83%97/id1090873328",
      appStoreUrl_Android:
        "https://play.google.com/store/apps/details?id=com.noelrecords.sekkyakueigo",
      newAppiOS: "縮小カメラiOS",
      newAppAndroid: "縮小カメラAndroid",
      newAppImg: require("./assets/newAppIcon.png"),
      iOSStoreUrl:
        "https://apps.apple.com/us/app/reduction-camera/id1540914691",
      googleStoreUrl:
        "https://play.google.com/store/apps/details?id=com.noelrecords.resizeCamera",
      newAppIconHeight: { height: "70px" },
      newAppIconHeight2: { height: "40px" },
      newAppiOS2: "縮小カメラfreeiOS",
      appDescription1:
        "このアプリは、解像度を落としてファイル容量を小さくした状態で撮影できるカメラアプリです。\n既に撮影されている画像を開いて解像度を小さくすることも可能です。\n↓に広告ありの無料版もあります。",
      appDescription2:
        "広告ありの無料版です。\n有料版の前にこちらをお試しください。",
      newAppAndroid2: "縮小カメラfreeAndroid",
      newAppImg2: require("./assets/newAppIcon_basic.png"),
      iOSStoreUrl2:
        "https://apps.apple.com/us/app/reduction-camera-basic/id1545738193",
      googleStoreUrl2:
        "https://play.google.com/store/apps/details?id=com.noelrecords.resizeCamera.free",
      youtube: "YouTube",
      youtubeImg: require("./assets/youtubeLogo.png"),
      youtubeUrl: "https://www.youtube.com/channel/UCiSfMiEnihaQbom4dhIZBpQ/",
      youtubeHeight: { height: "35px" },
      note_programming: "note（プログラミング）",
      noteImg: require("./assets/noteLogo.png"),
      noteHeight: { height: "45px" },
      note_programmingUrl: "https://note.com/noelrecords/m/maaa69d28154c",
      iOS: "iOS (App Store)",
      iOSImg: require("./assets/appStore.png"),
      iOSUrl:
        "https://apps.apple.com/jp/developer/yasuhiro-takano/id1072075743?l=ja",
      android: "Android (Google Play Store)",
      androidImg: require("./assets/googlePlayStore.png"),
      androidUrl:
        "https://play.google.com/store/apps/dev?id=7018349861892896519",
      instagram: "Instagram",
      instagramImg: require("./assets/IG.png"),
      instagramHeight: { height: "70px" },
      instagramUrl: "https://www.instagram.com/noelrecords_apps/",
      twitter: "Twitter",
      twitterImg: require("./assets/TwitterLogo.png"),
      twitterHeight: { height: "70px" },
      twitterUrl: "https://twitter.com/NoelRecords_App",
      note_eng: "note（英語コラム）",
      note_engUrl: "https://note.com/noelrecords/m/m0c756d3160d7",
      isPC: {},
    };
  },
  methods: {
    handleResize: function() {
      if (window.innerWidth <= 700) {
        this.isPC = false;
        this.positionChange = "center";
      } else {
        this.isPC = true;
        this.positionChange = "center";
      }
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  unmounted() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style>
#screen {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-image: url("./assets/macbookpro.png");
  /* background-color: rgba(255, 255, 255, 0.8); */
  background-color: white;
  background-blend-mode: lighten;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  height: auto;
  /* margin:0px ; */
  white-space: pre-line;
  margin-bottom: 10%;
}
#header {
  display: flex;
  top: 0px;
  height: 60px;
  width: 100%;
  align-self: center;
  /* margin-left: 8%; */
  margin-bottom: 0px;
  align-items: center;
  position: fixed;
  background: white;
  /* justify-content:center; */
  /* justify-content:flex-start; */
}
#header2 {
  /* display: flex; */
  top: 40px;
  margin-top: 0;
  /* margin: left 0px; */
  height: 60px;
  width: 100%;
  align-self: center;
  /* margin-left: 8%; */
  align-items: center;
  position: fixed;
  /* background: red; */
  justify-content: center;
  justify-content: flex-start;
}

#content {
  margin-top: 100px;
}
#nr {
  height: 35px;
}
.thema {
  text-align: center;
  margin-top: 60px;
  font-size: 23px;
  font-weight: bold;
}
#title {
  font-size: 20px;
  margin-left: 10px;
}
.youtube {
  width: 100%;
  aspect-ratio: 16 / 9;
}
.youtube iframe {
  margin: 50px;
  width: 90%;
  height: 90%;
  margin-left: 5%;
}
.icons {
  /* display: flex; */
  width: 70%;
  margin-left: 15%;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.appText {
  margin-left: 15%;
  width: 70%;
  display: flex;
}
.banner {
  width: 33%;
}
.PC {
  display: flex;
}
.PC2 {
  /* margin-left: 8%; */
}
.PC3 {
  text-align: left;
  margin-left: 15%;
}
.PC4 {
  width: 33%;
  margin-left: 0%;
  text-align: left;
}
.PC5 {
  width: 50%;
  height: 50%;
  margin-left: 25%;
}

#end {
  margin-top: 5%;
}
</style>
